import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
const NotFoundPage = () => {
    return (_jsxs("div", { className: "min-h-screen flex flex-col items-center justify-center bg-background", children: [_jsx("h1", { className: "text-6xl font-bold text-primary", children: "404" }), _jsx("p", { className: "mt-4 text-xl text-foreground", children: "Page Not Found" }), _jsx(Link, { to: "/", className: "mt-6 text-primary hover:underline", children: "Go Back Home" })] }));
};
export default NotFoundPage;
